import TemplateView from '../../../../../TemplateView'
import {hostingZone} from '../../../constants'
import messageResource from '../../../../../messageResource'

export default class AddressChangesNote extends TemplateView {

    constructor({noteTextKey}) {
        super()

        this.params = {
            noteTextKey,
        }

        this.state = {
            hostingZone: '',
            isHostingZoneChanged: false,
            context: '',
            isContextChanged: false,
        }

        this.onStatePropertyChanged('hostingZone', () => {
            const hostingZoneText = this.state.hostingZone === hostingZone.NORTH_AMERICA ?
                                    messageResource.getMessage('licenses.purchase_lightbox.review_context.zone_online')
                                    : messageResource.getMessage('licenses.purchase_lightbox.review_context.zone_eu')
            this.$hostingZone.text(hostingZoneText)
        })

        this.onStatePropertyChanged('isHostingZoneChanged', (isHostingZoneChanged) => {
            this.$hostingZone.toggleClass('wasChanged', isHostingZoneChanged)
        })

        this.onStatePropertyChanged('context', (context) => this.$context.text(context))

        this.onStatePropertyChanged('isContextChanged', (isContextChanged) => this.$context.toggleClass('wasChanged', isContextChanged))
    }

    templateHtml() {
        return '<div class="addressChanges">' +
               '    <div class="addressChangesNote"><%=addressChangesNoteText%></div>' +
               '    <div class="newAddress">' +
               '        <span class="http"><%=httpText%></span>' +
               '        <span class="hostingZone"/>' +
               '        <span class="mainAddress"><%=mainAddressText%></span>' +
               '        <span class="context"/>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            addressChangesNoteText: this.params.noteTextKey,
            httpText: 'licenses.purchase.success.purchase_title_change_address_note.address.http',
            mainAddressText: 'licenses.purchase.success.purchase_title_change_address_note.address.main',
        }
    }



    afterRender() {
        this.$hostingZone = this.find('.hostingZone')
        this.$context = this.find('.context')
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/successStep/AddressChangesNote.js